import { render, staticRenderFns } from "./addNewTask.vue?vue&type=template&id=0839f980&scoped=true&"
import script from "./addNewTask.vue?vue&type=script&lang=js&"
export * from "./addNewTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839f980",
  null
  
)

export default component.exports